import { WebView } from '@zenbusiness/application-commons-webview';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import ConfirmCancelTransactionModal from '#client/components/ConfirmCancelPaymentModal';
import { PHONE_NUMBER } from '#client/constants/phone';
import useModalContext from '#client/hooks/useModalContext';

import { PrintButtonStyle } from './style';

const PrintButton = styled(Button)(PrintButtonStyle);

export default function AdditionalPaymentInfo({
  handlePrint = () => {},
  isPending,
  id,
  refetchPayment
}) {
  const { isWebView } = WebView;
  const { openModal, clearAllModal } = useModalContext();

  const handleSuccessCancelPayment = () => {
    if (typeof refetchPayment === 'function') {
      refetchPayment();
    }
    clearAllModal();
  };

  const handleCancelTransaction = () => {
    openModal({
      component: ConfirmCancelTransactionModal,
      id,
      handleSuccess: handleSuccessCancelPayment
    });
  };

  return (
    <Stack
      alignItems={{ xs: 'left', md: 'center' }}
      flexDirection={{ xs: 'column', md: 'row' }}
      gap="16px"
      justifyContent="space-between"
      mt={{ xs: '32px', md: '40px' }}
    >
      {!isWebView && (
        <Box>
          <PrintButton
            color="info"
            onClick={handlePrint}
            size="small"
            variant="text"
          >
            Print this page
          </PrintButton>
        </Box>
      )}
      <Text
        color="primary"
        size="sm"
        weight="medium"
      >
        Notice a problem? Call{' '}
        <Link
          href={`tel:${PHONE_NUMBER}`}
          size="sm"
          underline="none"
          weight="medium"
        >
          {PHONE_NUMBER}
        </Link>
        {isPending && (
          <>
            {' or '}
            <Text
              as="span"
              color="blue"
              onClick={handleCancelTransaction}
              size="sm"
              sx={{ cursor: 'pointer' }}
              weight="medium"
            >
              cancel transaction
            </Text>
          </>
        )}
      </Text>
    </Stack>
  );
}

AdditionalPaymentInfo.propTypes = {
  id: PropTypes.string.isRequired,
  isPending: PropTypes.bool.isRequired,
  handlePrint: PropTypes.func,
  refetchPayment: PropTypes.func
};
